import React, { useContext } from 'react'
import { View } from 'oio-react'
import EventDetailsBlock from 'src/sites/kits/Events/components/DetailsBlock'
import ObjectCoverImage from 'src/sites/kits/Object/components/CoverImage'
import ObjectUpvoteControl from 'src/sites/kits/Object/components/UpvoteControl'
import { InitiativeHierarchyContext } from 'src/sites/kits/Utils/InitiativeHierarchy'
import ObjectActionBar from './ActionBar'
import ObjectDescriptionBlock from './DescriptionBlock'
import ObjectFileAttachmentsBlock from './FileAttachmentsBlock'
import ObjectSurveyBlock from './SurveyBlock'
import ObjectTagBlock from './TagBlock'

const ObjectViewBody = () => {
   const { initiative } = useContext(InitiativeHierarchyContext)
   const coverImageUrl = initiative.coverMedia?.file.thumbnailUrlW1600
   const showBannerCoverImage = ['post'].includes(initiative.class)

   return (
      <>
         {initiative.class === 'event' && (
            <View display="block[a-c] none[d-f]">
               <EventDetailsBlock />
            </View>
         )}
         {['discussion', 'post'].includes(initiative.class) && (
            <ObjectActionBar showOriginalAuthor />
         )}
         {coverImageUrl && showBannerCoverImage && (
            <View width="100%" marginBottom="30px">
               <ObjectCoverImage
                  aspectRatio={0.5625}
                  borderRadius="8px"
               />
            </View>
         )}
         <ObjectDescriptionBlock truncateText={initiative.class === 'group'} />
         <ObjectSurveyBlock />
         <ObjectFileAttachmentsBlock />
         <ObjectTagBlock />
         <ObjectUpvoteControl />
      </>
   )
}

export default ObjectViewBody
